import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/EquipmentNotesAction";
import * as api from "../../api/EquipmentNotesApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showErrorSnackbar, showSuccessSnackbar } from "../actions/SnackbarActions";

function* getEquipmentNotes(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.getEquipmentNotes(action);
        console.log(data);
        yield put(actions.setEquipmentNotes(data || undefined));
    } catch (error) {
        yield put(actions.getEquipmentNotes(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addEquipmentNote(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addEquipmentNote(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateEquipmentNote(action) {
    yield put(resetBackdrop());
    try {
        console.log(action);
        const data = yield api.updateEquipmentNote(action.payload);
        console.log(data);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log(error);
        yield put(showErrorSnackbar(error));
    }
    yield put(resetBackdrop());
}

function* deleteEquipmentNote(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteEquipmentNote(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_EQUIPMENT_NOTES, getEquipmentNotes);
    yield takeEvery(actions.Types.ADD_EQUIPMENT_NOTE, addEquipmentNote);
    yield takeEvery(actions.Types.UPDATE_EQUIPMENT_NOTE, updateEquipmentNote);
    yield takeEvery(actions.Types.DELETE_EQUIPMENT_NOTE, deleteEquipmentNote);
}

const equipmentNotesSaga = [fork(watchAll)];

export default equipmentNotesSaga;
